// extracted by mini-css-extract-plugin
export var wordContainer = "_rm-0";